import { SnowplowService } from 'wanderu-service-analytics';

function clicked({ navType, label, action = 'click' }) {
    SnowplowService.fireStructuredEvent({
        category: 'navigation',
        action,
        label,
        property: {
            nav_type: navType,
        },
    });
}

export default {
    clicked,
};
